import { StatusType } from '@oy/types';
import { Pill, PillColor, PillSize, TablePill } from '@oy/uidesktop';
import { startCase, toLower } from 'lodash-es';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useStatusMap } from 'src/hooks';

type StatusPillProps = {
  status: StatusType;
  customSideComponent?: JSX.Element | string;
  id?: string;
  tooltipContent?: string;
  customColor?: PillColor;
  size?: PillSize;
};

export const StatusPill = ({
  status,
  customSideComponent,
  id,
  tooltipContent,
  customColor,
  size,
}: StatusPillProps) => {
  const { getPillThemeByStatus } = useStatusMap();
  const { color, text } = getPillThemeByStatus(status);
  const [showTooltipMessage, setShowTooltipMessage] = useState(false);

  return (
    <>
      {!tooltipContent && (
        <Pill
          id={id}
          color={customColor ? customColor : color}
          size={size ? size : PillSize.Medium}
        >
          {text}
          {customSideComponent}
        </Pill>
      )}
      {tooltipContent && id && (
        <>
          <div
            id={`status_${id}`}
            onMouseOver={() => setShowTooltipMessage(true)}
            onMouseOut={() => setShowTooltipMessage(false)}
          >
            <Pill id={id} color={customColor ? customColor : color}>
              {text}
              {customSideComponent}
            </Pill>
          </div>
          <Tooltip
            isOpen={showTooltipMessage}
            target={`status_${id}`}
            placement={'bottom'}
          >
            {tooltipContent}
          </Tooltip>
        </>
      )}
    </>
  );
};

export const StatusPillV2 = ({
  status,
  customSideComponent,
  id,
}: StatusPillProps) => {
  const { getPillColorByStatus } = useStatusMap();
  const { color, text } = getPillColorByStatus(status);
  return (
    <TablePill id={id} color={color}>
      {startCase(toLower(text))}
      {customSideComponent}
    </TablePill>
  );
};
